import axios from "axios";
import config from "../config";

export const getBlog = async (id) => {
    const response = await axios.get(`${config.API_BASE_URL}/blog/get`, { 
        params: {
            id
        }
    });
    if (response != null) {
        return response.data;
    }
    return null;
}

export const getBlogs = async () => {
    const response = await axios.get(`${config.API_BASE_URL}/blog/all`);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const createBlog = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/blog/create`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const updateBlog = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/blog/update`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const deleteBlog = async (id) => {
    const response = await axios.post(`${config.API_BASE_URL}/blog/delete?id=${id}`);
    if (response != null) {
        return response.data;
    }
    return null;
}